module.exports = __webpack_public_path__ + "img/logo-icon.d19c7590.png";